import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useQuery } from 'react-query';
import api from 'utils/api';
function useFetchList(path) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var queryOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  path = "/api/".concat(path);
  function fetchRequest() {
    return _fetchRequest.apply(this, arguments);
  } // Default queryKey is the path split by slashes, i.e. /api/me/playlist/123/content?search=123 => ['api', 'me', 'playlist', '123', 'content', {search: 'abd'}]
  function _fetchRequest() {
    _fetchRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api('get', path, query);
          case 2:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchRequest.apply(this, arguments);
  }
  var _queryOptions$queryKe = queryOptions.queryKey,
    queryKey = _queryOptions$queryKe === void 0 ? path.split('/').filter(Boolean) : _queryOptions$queryKe;
  var queryKeys = [].concat(_toConsumableArray(queryKey), [query]);
  var _useQuery = useQuery(queryKeys, fetchRequest, queryOptions),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    items: (data === null || data === void 0 ? void 0 : data.items) || []
  }, result);
}
export default useFetchList;